import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import ContactPage from './pages/ContactPage';
import SEOHelmet from './components/SEOHelmet';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <SEOHelmet 
        title="Ana Sayfa"
        description="5N1PR İletişim Danışmanlığı olarak, kurumsal iletişim ve PR çözümleriyle markanızı bir adım öne taşıyoruz."
        keywords="PR, iletişim danışmanlığı, kurumsal iletişim, medya ilişkileri, sosyal medya yönetimi"
        canonicalUrl="https://www.5n1pr.com"
      />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/hakkimizda" element={<AboutPage />} />
          <Route path="/hizmetlerimiz" element={<ServicesPage />} />
          <Route path="/hizmetlerimiz/:serviceId" element={<ServiceDetailPage />} />
          <Route path="/iletisim" element={<ContactPage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;